import { Component, Input, OnInit } from '@angular/core';
import { Entity } from '../entities.model';

@Component({
    selector: 'app-entity-detail',
    templateUrl: './entity-detail.component.html',
    styleUrls: ['./entity-detail.component.scss'],
    standalone: false
})
export class EntityDetailComponent implements OnInit {

  @Input() entity: Entity | null = null;
  @Input() readOnly: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Format date for display
   */
  formatDate(dateString: string | undefined): string {
    if (!dateString) return '-';
    const value = String(dateString).trim();
    const isoDateMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoDateMatch) {
      return `${isoDateMatch[2]}/${isoDateMatch[3]}/${isoDateMatch[1]}`;
    }

    const usDateMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (usDateMatch) {
      const month = usDateMatch[1].padStart(2, '0');
      const day = usDateMatch[2].padStart(2, '0');
      return `${month}/${day}/${usDateMatch[3]}`;
    }

    return dateString;
  }
}
